import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import { LOUNGE_PASSES_PAGE } from 'loyalty/constants/loyaltyRoutes'

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
}

function LandingPageLoyaltyLoungePass(props: Props) {
  const { tier, benefitLabel } = props
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: 'rq13k5lzgr8oxoz3a2',
    title: intl.formatMessage({
      id: 'gQEACgdYwlO-8dARU_x9',
      defaultMessage: 'Free airport lounge passes',
      description: 'Alternative text fallback for the airport lounge pass loyalty benefit image',
    }),
  }), [intl])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'c9p-4SjsKWKqzrAh-aoA',
      defaultMessage: 'Free airport lounge passes',
      description: 'Heading for loyalty airport lounge pass benefit tile',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" to={`/${LOUNGE_PASSES_PAGE}`}>
      {intl.formatMessage({
        id: 'OeFquzYl5aVyjovyZN0W',
        defaultMessage: 'Details',
        description: 'Link to open lounge pass benefit details modal on the promotional landing page',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'LjLE26Cgfe6gep7CuZSD',
        defaultMessage: 'Kick off your trip in comfort with complimentary access to select airport lounges. Recharge with a drink, a bite to eat, and space to relax before your international flight. Simply add to your booking when checking out for your overseas escapes.',
        description: 'Description of the complimentary airport lounge pass loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyLoungePass
